export default {
  SHOW_PAY_DIALOG: "show-pay-dialog",
  PAY_SUCCESS: "pay-success",
  PAY_SUCCESS_KNOW: "pay-success-know",
  CONTENT_SEARCH: "content-search",
};
